module.exports = __webpack_public_path__ + "img/gallery3.ff9b332a.jpg";